// src/libs/mixins/remittanceExport.js
import qs from "qs";
import transactionInfo from "@/api/transactionInfo";

export default {
  methods: {
    buildFilters() {
      const f = this.queryForm || {};
      const p = {};
      if (f.phone) p.phone = String(f.phone).replace(/\s/g, "");
      if (f.idCard) p.idCard = String(f.idCard).trim();
      if (f.customerType) p.customerType = f.customerType;
      if (f.regionId) p.regionId = f.regionId;
      if (f.orgInfoId) p.orgInfoId = f.orgInfoId;
      if (f.status !== undefined && f.status !== null && f.status !== "")
        p.status = f.status;
      if (Array.isArray(f.date) && f.date.length === 2) {
        p.startDate = this.$manba(f.date[0]).format("ymd");
        p.endDate = this.$manba(f.date[1]).format("ymd");
      }
      delete p.date;
      return p;
    },

    downloadEXCEL() {
      const url =
        transactionInfo.remittancesExport +
        "?" +
        qs.stringify({ kind: this.exportKind, ...this.buildFilters() });
      const a = document.createElement("a");
      a.href = url;
      a.download = "";
      a.click();
    },
  },
};
